function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { chain } from 'lodash';
import { tap } from 'rxjs';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
import { BloqueForm } from '../../../data/bloque-form';
import { BaseFeaturesComponent } from '../_base/base-features.component';
var TarjetaFormularComponentCtrl = /*#__PURE__*/function (_BaseFeaturesComponen) {
  TarjetaFormularComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos", "appConfigService"];
  function TarjetaFormularComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos, appConfigService) {
    var _this;
    _classCallCheck(this, TarjetaFormularComponentCtrl);
    _this = _callSuper(this, TarjetaFormularComponentCtrl, [appConfigService]);
    _defineProperty(_this, "dirty", false);
    _defineProperty(_this, "defaultactive", '');
    _defineProperty(_this, "editaDocAttach", false);
    _this.$element = $element;
    _this.$timeout = $timeout;
    _this.$log = $log;
    _this.NotifService = NotifService;
    _this.AccesoDatos = AccesoDatos;
    _this.autoUnsub(
    //
    _this._flags.pipe(tap(function (flags) {
      _this.editaDocAttach = flags.editaAccesoPublico;
    })).subscribe());
    return _this;
  }
  _inherits(TarjetaFormularComponentCtrl, _BaseFeaturesComponen);
  return _createClass(TarjetaFormularComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[TarjetaFormularComponentCtrl] onInit');
      if (this.edit) this.verSeccionesForm();
      this.defaultactive = this.formular.esNuevo ? '' : 'active';
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this2 = this;
      this.$timeout(function () {
        return _this2._initDrop();
      }, 200);
    }
  }, {
    key: "_initDrop",
    value: function _initDrop() {
      var elems = this.$element.find('.dropdown-trigger');
      M.Dropdown.init(elems, {
        hover: false,
        constrainWidth: false,
        alignment: 'right'
      });
    }
  }, {
    key: "verSeccionesForm",
    value: function verSeccionesForm() {
      var _this3 = this;
      this.formular.esNuevo = false;

      // leer el formulario si no lo está ya
      if (!this.formdata) {
        this.refreshForm().then(function () {
          _this3.verSecciones = !_this3.verSecciones;
        });
      } else this.verSecciones = !this.verSecciones;
    }
  }, {
    key: "refreshForm",
    value: function refreshForm() {
      var _this4 = this;
      return this.AccesoDatos.EdicionFormular_CLIENT.leerFormulario(this.formular.data.idform).then(function (response) {
        _this4.formdata = response;
        _this4.bloques = chain(response.bloques).map(function (b) {
          return new BloqueForm(b);
        }).value();
      });
    }
  }, {
    key: "guardarFormular",
    value: function guardarFormular() {
      var _this5 = this;
      this.formular.esNuevo = false;
      this.AccesoDatos.EdicionFormular_CLIENT.actualizaForm(this.formular).then(function (response) {
        _this5.formular.actualiza(response);
        _this5.dirty = false;
      });
    }
  }, {
    key: "nuevoBloque",
    value: function nuevoBloque() {
      this.bloques.push(new BloqueForm({
        data: {
          formular_id: this.formular.data.idform
        }
      }));
    }
  }, {
    key: "duplicarFormulario",
    value: function duplicarFormulario() {
      var _this6 = this;
      this.AccesoDatos.EdicionFormular_CLIENT.duplicaFormulario(this.formular.data.idform).then(function (response) {
        _this6.NotifService.good('El nuevo formulario está al final');
        _this6.onNuevoForm({
          form: response
        });
      });
    }
  }]);
}(BaseFeaturesComponent);
angular.module('candidato').component('tarjetaFormular', {
  bindings: {
    formular: '<',
    edit: '<',
    onAdd: '&',
    onNuevoForm: '&'
  },
  controller: TarjetaFormularComponentCtrl,
  template: require('./tarjeta-formular.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-formular/tarjeta-formular.component.html"
});